import { Navbar } from "@/components/Navbar";
import { KineticHero } from "@/components/KineticHero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { RepProgram } from "@/components/RepProgram";
import { CoachBio } from "@/components/CoachBio";
import { ManifestoSection } from "@/components/ManifestoSection";
import { Programs } from "@/components/Programs";
import { Testimonials } from "@/components/Testimonials";
import { InquiryForm } from "@/components/InquiryForm";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main className="relative">
      <Navbar />
      <KineticHero />
      <EditorialMarquee />
      <RepProgram />
      <CoachBio />
      <ManifestoSection />
      <Programs />
      <Testimonials />
      <InquiryForm />
      <Footer />
    </main>
  );
}
